"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitWindowEventOnConsentEvaluated = emitWindowEventOnConsentEvaluated;
exports.emitWindowEventOnConsentChanged = emitWindowEventOnConsentChanged;
const genericTrackingData_1 = require("./genericTrackingData");
function emitWindowEventOnConsentEvaluated() {
    const event = new CustomEvent('OneSegmentConsentEvaluated');
    window.dispatchEvent(event);
}
function emitWindowEventOnConsentChanged() {
    const oneSegmentConsentChangedEvent = new CustomEvent('OneSegmentConsentChanged');
    window.dispatchEvent(oneSegmentConsentChangedEvent);
    const consentChangedEvent = new MessageEvent('message', {
        data: {
            eventName: 'consentChanged',
            data: (0, genericTrackingData_1.getGenericTrackingData)().consentLevel,
        },
    });
    window.dispatchEvent(consentChangedEvent);
}
//# sourceMappingURL=windowEventHelper.js.map